import { atomWithReset } from "jotai/utils";

export interface RegulatoryDocumentRequestResult {
  codUnidade: number;
  nomeUnidade: string;
  enderecoUnidade: string;
  urlDownload: string;
  nomeArquivo: string;
}

export const regulatoryDocumentResultAtom = atomWithReset<
  RegulatoryDocumentRequestResult[]
>([]);
